import React from 'react';
export function InfoCircleFillIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.006 22.008c5.524 0 10.002-4.478 10.002-10.002 0-5.524-4.478-10.002-10.002-10.002-5.524 0-10.002 4.478-10.002 10.002 0 5.524 4.478 10.002 10.002 10.002zm0-13.003a1 1 0 100-2 1 1 0 000 2zm.992 6.002l.009-4a1 1 0 00-1-1.002h-1a1 1 0 00-.003 2l-.006 3.002a1 1 0 00.008 2h2a1 1 0 100-2h-.008z"
  }));
}